export default {
  route: 'data.trurisk.io',
  aws: {
    region: 'eu-west-1',
    aws_appsync_graphqlEndpoint: 'https://irvwgmzcdff5hexxcqenrelusa.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_apiKey: 'da2-wqjksn35ybh25aeph6aspyxblu',
    cookie_domain: 'data.trurisk.io',
  },
  bucket: {
    PRIVATE_UPLOAD_BUCKET: 'tr-trurisk-data-media-document-upload-1',
    PRIVATE_DOWNLOAD_BUCKET: 'tr-trurisk-data-media-document-target-1',
    DOWNLOAD_REPORTS_BUCKET: 'tr-trurisk-data-media-document-renderer-output-1',
    PUBLIC_BUCKET: 'tr-trurisk-data-userimages-1',
  },
  GOOGLE_MAP_API_KEY: 'AIzaSyDf9gYmAByusdy4DYoFshXO2lS3SX9wqxM',
};
